import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';

class CashFlowChartView extends Component {
  constructor(props) {
    super(props);

    const { fetch_data, clientId } = this.props;

    fetch_data(clientId);
  }

  handleButton() {
    const { clientId } = this.props;

    ADV.util.Router.go2('ProfileAccounts', { clientId });
  }

  render() {
    const { inc_chart_data, exp_chart_data, is_initialized, inc_total, exp_total } = this.props;

    if (!is_initialized) {
      return null;
    }

    return (
      <div id="cfc_reactor">
        <div className="chart">
          {Object.keys(inc_chart_data).length > 0 && inc_chart_data && (
            <ReactHighcharts
              className="constrained"
              container="cfc_inc_chart"
              options={inc_chart_data}
            />
          )}

          {Object.keys(inc_chart_data).length > 0 && inc_chart_data && (
            <div className="TotalLabel" data-content="Income">
              ${ADV.util.number_format(inc_total)}
            </div>
          )}
        </div>

        <div className="chart">
          {Object.keys(exp_chart_data).length > 0 && exp_chart_data && (
            <ReactHighcharts
              className="constrained"
              container="cfc_exp_chart"
              options={exp_chart_data}
            />
          )}

          {Object.keys(exp_chart_data).length > 0 && exp_chart_data && (
            <div className="TotalLabel" data-content="Expenses">
              ${ADV.util.number_format(exp_total)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

CashFlowChartView.propTypes = {};

export default CashFlowChartView;
